export default __webpack_public_path__ + "static/media/ai_governance_total_ai_assets.1e2cda1c.svg";